export { default } from './IconManage'
